<template>
  <main class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6 text-center">
        <div class="card shadow">
          <div class="card-header">
            <h1
              class="fw-bold my-auto text-start"
              role="heading"
              aria-level="1"
            >
              <span class="bi bi-images" aria-hidden="true"></span>
              {{ title }}
            </h1>
          </div>
          <div class="card-body">
            <p class="lead my-auto text-start" role="heading" aria-level="2">
              {{ description }}
            </p>
          </div>
          <div class="card-footer py-3">
            <RouterLink
              :to="{ name: 'ImageSelect' }"
              class="btn btn-primary mx-auto btn-lg fw-bold"
              aria-labelledby="continue-label"
              role="button"
            >
              <span id="continue-label">Continue to Gallery</span>
              <span class="bi-arrow-right ms-2" aria-hidden="true"></span>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import config from "@/data/config.json";
export default {
  name: "IntroView",
  data() {
    return {
      title: config.landingView.title,
      description: config.landingView.description,
      image: config.landingView.image
    };
  }
};
</script>
